import React, { useState, useEffect, useContext } from 'react'
import { httprequesthandler } from './httprequesthandler';
// import axios from 'axios';

const AppContext = React.createContext()

var distributor_data = [];

const AppProvider = ({ children }) => {

    const [menuList, setMenuList] = useState([]);
    const [menuListDummy, setMenuListDummy] = useState([]);
    const [distributorList, setDistributorList] = useState([]);

    // const [popUp, setPopUp] = useState([]);
    // const [data, setData] = useState();


    const datafetch = () => {
        httprequesthandler('data.json').then(function (data) {
            // console.log(data)
            var menuData;
            menuData = data.EN.menus.filter(val => val.menuVisibility !== 'hide')
            //   popUpData = data.EN.popupContent.filter(val => val.menuVisibility !== 'hide')
            //    console.log(popUpData)
            return menuData;
            // setMenuList(menuData);
        }).then(function (menuData) {

            setMenuList(menuData);

            setMenuListDummy(menuData);

            // setPopUp(popUpData);

        }).then(function () {
            //    console.log("the distributor content");
        });
    }

    // console.log("the data inside the menuList is", menuList);

    // distributor code commented
    // const distributor = () => {
    //     // console.log('distributor called', menuList)
    //     // httprequesthandler('https://www.hmxmedia.com/wp-content/sharp/distributor-v4.php').then(function (data) {
    //     httprequesthandler('setInterval(() => { https://www.hmxmedia.com/wp-content/sharp/distributor-24inch.php?v=2}, interval);').then(function (data) {
    //         // console.log(data)
    //         var menuData;
    //         // return menuData = data.menus.EN.filter(val => val.menuVisibility !== 'hide')
    //         // setMenuList(menuData);

    //         var ldata = data;
    //         // console.log('ldata', ldata[0].distributor);

    //         return menuData = ldata[0].distributor;
    //     }).then(function (menuData) {
    //         // setData(menuData);
    //         setDistributorList(menuData);
    //         distributor_data = menuData;
    //         // console.log("menuData 60",menuData)
    //         // console.log("distributor_data 60",distributor_data)
    //     }).then(function () {
    //         // setTimeout(() => {
    //         // console.log('distributor_updated called', menuList);
    //         // distributor_updated();
    //         // }, 4000);
    //         // console.log('data', data);
    //     });
    //     // var xhttp = new XMLHttpRequest();
    //     // xhttp.onreadystatechange = function () {
    //     //     if (this.readyState == 4 && this.status == 200) {
    //     //         var ldata = JSON.parse(this.responseText);
    //     //         // var ldata = (this.responseText);
    //     //         // console.log(ldata[0].distributor);
    //     //         // console.log('ldata',ldata.distributor);
    //     //         distributor_data = ldata[0].distributor;
    //     //         setData(ldata[0].distributor)
    //     //         // distributor_updated();
    //     //         console.log("here is the data contained by distributor_data in smith", distributor_data.Smith);
    //     //         console.log("here is the data contained by distributor_data", distributor_data);
    //     //         console.log("here is the data contained by distributor_data in Jones", distributor_data.Jones);
    //     //     }
    //     // };
    //     // xhttp.open("GET", "https://www.hmxmedia.com/wp-content/sharp/distributor-v4.php", true);
    //     // xhttp.send();
    // }

    const distributor = () => {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var ldata = JSON.parse(this.responseText);
                // var ldata = (this.responseText);
                // console.log(ldata[0].distributor);
                // console.log('ldata', ldata.distributor);
                distributor_data = ldata.distributor;
            }
        };
        xhttp.open("GET", "distributor.json", true);
        xhttp.send();

    }

    const distributorUpdated = () => {

        // distributor();

        // setTimeout(() => {
        // console.log('distributor_updated called');
        // console.log('data', data);
        const windowUrl = window.location.search;
        // console.log("the windowUrl content", windowUrl);
        const urlParams = new URLSearchParams(windowUrl);
        // console.log("the urlParams content", urlParams);
        let distributors_url = urlParams.get('distributor');

        // console.log(distributors_url,'distributors_url----')

        // console.log("$#$#$#$#$# 100 distributors_url", distributors_url);

        if (distributors_url !== null) {
            var distributorProductList = distributor_data[distributors_url];
        }

        //    else{
        //         var distributorProductList = distributor_data['defaultconfig'];
        //    }


        // console.log("$#$#$#$#$# distributor_data", distributor_data);
        // console.log("$#$#$#$#$# backend file distributorProductList", distributorProductList);

        // console.log('its running')
        if (distributorProductList !== undefined && distributorProductList.length > 0) {
            // console.log('its run in if condition')
            // console.log('data of menuList is', menuList);

            var newArr = menuList && menuList?.map((item) => {
                // console.log('its run in map ')
                // console.log('the item inside the map is 116', item)
                // console.log('the item inside the map is', item.items);
                // if(item.items.length == 0){
                //     item.splice(0,item.length);
                // }
                return {
                    ...item, items: item?.items?.filter((it) => distributorProductList.some((it2) => it2 === it.title))
                }
            })

            // console.log("the data inside the newArr is", newArr);

            var finalArr = newArr.filter((item) =>
                item?.items?.length != 0
            )
            setMenuList(finalArr);
        }

        // console.log("the data inside the finalArr is", finalArr);


    }


    // setTimeout(() => {
    //     DistributorUpdated();
    // }, 2000);



    useEffect(() => {
        if (menuList.length == 0) {
            datafetch();
        }
        if (distributorList.length == 0) {
            distributor(); // distributor code commented
        }
    }, [])
    useEffect(() => {
        distributorUpdated();
        // console.log('useEffect distributorUpdated called')
    }, [menuListDummy, distributorList])

    // const [menuList, setMenuList] = useState([]);
    // const [distributorList, setDistributorList] = useState([]);
    return (
        <AppContext.Provider
            value={{
                menuList
            }}>
            {children}
        </AppContext.Provider>
    )
}

export const useGlobalContext = () => {
    return useContext(AppContext)
}

export { AppContext, AppProvider }